import { Megaphone } from 'phosphor-react';
import { useShouldShowAd, getMockAd } from '@/lib/ads';

interface Props {
  /** Clé stable pour piocher la même mock-ad entre deux re-renders. */
  adKey?: string;
  className?: string;
}

/**
 * Item publicitaire intercalé dans la liste du bottom sheet Explorer.
 * Format identique à un EventCard variant="row", mais avec un Megaphone champagne
 * dans la colonne gauche au lieu de la date, et "SPONSORISÉ" comme catégorie.
 *
 * Au tap : ouvre l'URL de l'annonceur (mock pour l'instant).
 * Le compteur "X sorties" du header NE doit PAS inclure cet item.
 */
export function AdExplorerListItem({ adKey, className }: Props) {
  const visible = useShouldShowAd('explorer_list');
  if (!visible) return null;
  const ad = getMockAd(adKey);

  return (
    <a
      href={ad.url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      className={`flex gap-4 items-start py-3 group ${className ?? ''}`}
    >
      {/* Colonne gauche — Megaphone champagne (remplace la date MOIS+jour) */}
      <div className="flex flex-col items-center justify-center w-14 shrink-0">
        <Megaphone size={28} weight="regular" className="text-champagne" />
      </div>

      {/* Colonne droite — même structure qu'un row event card */}
      <div className="flex-1 min-w-0">
        <div className="t-cap mb-1 inline-flex items-center gap-1.5 text-champagne uppercase">
          Sponsorisé
        </div>
        <h3 className="t-ed-md leading-tight truncate group-hover:text-terre transition">
          {ad.headline}
        </h3>
        <div className="t-ui-sm text-ink-3 truncate">
          {ad.advertiser} · {ad.city}
        </div>
      </div>
    </a>
  );
}
